import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import EcoProButton from "../../components/shared/button/button";
import { 
    buildDirectServicePageQSNativeApp, 
    getShenlongQueryParams, 
    updateNativeAppQueryParams_LocalStorage
} from "../../constants/AppMethod";
import { 
    LOCALSESSIONDATAKEYS, 
    NATIVE_APP_SELECTION_ATTRIBUTE, 
    NATIVE_APP_SUBSCRIPTION_ATTRIBUTE 
} from "../../constants/AppConstants";
import { nativeAppRoutePaths } from "../../constants/Routes";
import { useDispatch } from "react-redux";
import { NativeAppLogsInit } from "../../store/NativeAppLogs/NativeAppLogsSlice";

const ErrorPageNativeApp = (props) => {
    const { t } = useTranslation(["translation"]);
    const { errorInfo }= props;
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch(NativeAppLogsInit({isError: true, errorPathname: location?.pathname}));
        // eslint-disable-next-line
    }, [])

    const handleTryAgain = () => {
        const {is_single_page_service} = getShenlongQueryParams() || {};
        const QS = (is_single_page_service) 
        ? buildDirectServicePageQSNativeApp(NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.SKIP) 
        :`&selection=${NATIVE_APP_SELECTION_ATTRIBUTE.SKIP}&subscription=${NATIVE_APP_SELECTION_ATTRIBUTE.SKIP}&brother_plus=${NATIVE_APP_SELECTION_ATTRIBUTE.SKIP}`;
        updateNativeAppQueryParams_LocalStorage(null, QS, LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);
        history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
    }

    return (
        <div className = 'error-content'>
            <div>
                <div className="error-header f-20 fc-e">
                    <div>{t("ERROR_CONTENT.HEADER1")}</div>
                    <div>{t("ERROR_CONTENT.HEADER2")}</div>
                </div>
                <p className="error-info f-12 fc-g mt-10">
                    {errorInfo ? errorInfo : t("ERROR_CONTENT.INFO_GENERAL")}
                </p>
                <div className="mt-30 refresh-btn">
                    <EcoProButton cname="default, native-app-error-page-btn" onBtnClick={handleTryAgain}>{t("ECOPRO_BTNS.CONTINUE")}</EcoProButton>
                </div>
            </div>
        </div>
    )
}

export default ErrorPageNativeApp